import { PropTypes } from "prop-types";
import React from "react";
import autoBind from "react-autobind";
import { unmountComponent } from "~/helpers/reactRoot";

class AppModal extends React.Component {
  constructor(props) {
    super(props);

    autoBind(this);
  }

  componentDidMount() {
    const $modal = $(this.modal);
    const { containerID } = this.props;
    this.returnFocus = document.activeElement;

    this.hideHandler = (event) => {
      if (this.props.beforeHide?.(event) === false) {
        event.preventDefault();
        return;
      }
      this.props.onHide(event);
      unmountComponent(document.getElementById(containerID));
    };
    $modal.on("hide.bs.modal", this.hideHandler);

    if (this.props.returnFocus) {
      this.siblingShowHandler = (event) => {
        if (
          event.target !== this.modal &&
          this.modal.contains(document.activeElement)
        ) {
          this.confirmationReturnFocus = document.activeElement;
        }
      };
      this.siblingHiddenHandler = (event) => {
        const instance = $modal.data("bs.modal");
        if (
          instance?._isShown &&
          instance._config.focus &&
          event.target !== this.modal &&
          // React can replace Bootstrap's show class on compact-to-preview updates.
          $(".modal")
            .toArray()
            .filter((modal) => $(modal).data("bs.modal")?._isShown)
            .at(-1) === this.modal
        ) {
          // Bootstrap 4 removes the shared focus handler when a stacked modal hides.
          instance._enforceFocus();
          const target = this.confirmationReturnFocus;
          (target?.isConnected && this.modal.contains(target)
            ? target
            : this.modal
          ).focus();
        }
      };
      $(document).on("show.bs.modal", this.siblingShowHandler);
      $(document).on("hidden.bs.modal", this.siblingHiddenHandler);
    }

    $modal.modal({ keyboard: false, backdrop: "static" });
  }

  componentWillUnmount() {
    if (this.siblingShowHandler) {
      $(document).off("show.bs.modal", this.siblingShowHandler);
      $(document).off("hidden.bs.modal", this.siblingHiddenHandler);
    }
    $(this.modal).off("hide.bs.modal", this.hideHandler);
    $(this.modal).modal("hide");
    if (this.props.returnFocus && this.returnFocus?.isConnected) {
      this.returnFocus.focus();
    }
  }

  render() {
    const { id, modalClass, dialogClass, contentClass, children } = this.props;

    return (
      <div
        className={modalClass}
        id={id}
        ref={(modal) => (this.modal = modal)}
        role="dialog"
        tabIndex={this.props.returnFocus ? -1 : undefined}
        aria-labelledby={this.props.labelledBy}
        onKeyDown={(event) => {
          if (
            event.key === "Tab" &&
            !event.defaultPrevented &&
            this.props.returnFocus &&
            $(this.modal).data("bs.modal")?._config.focus
          ) {
            const controls = Array.from(
              this.modal.querySelectorAll(
                "a[href], button, input, select, textarea, [tabindex]",
              ),
            ).filter(
              (control) =>
                control.tabIndex >= 0 &&
                !control.matches(":disabled") &&
                !control.closest("[inert]") &&
                getComputedStyle(control).visibility === "visible" &&
                control.getClientRects().length > 0,
            );
            const first = controls[0];
            const last = controls[controls.length - 1];
            const target = event.shiftKey
              ? (event.target === first || event.target === this.modal) && last
              : event.target === last && first;
            if (target) {
              event.preventDefault();
              target.focus();
            }
          }
          if (this.props.keyboard && event.key === "Escape") {
            $(this.modal).modal("hide");
          }
        }}
        onClick={(event) => {
          if (
            this.props.backdrop === true &&
            event.target === event.currentTarget
          ) {
            $(this.modal).modal("hide");
          }
        }}
        aria-hidden="true"
      >
        <div className={dialogClass} role="document">
          <div className={contentClass}>{children}</div>
        </div>
      </div>
    );
  }
}

AppModal.defaultProps = {
  containerID: "primary-modal",
  id: "modal-dialog",
  modalClass: "modal",
  dialogClass: "modal-dialog",
  contentClass: "modal-content",
  children: [],
  onHide: () => false,
  beforeHide: undefined,
  keyboard: false,
  backdrop: "static",
  labelledBy: "appModalLabel",
  returnFocus: false,
};

AppModal.propTypes = {
  containerID: PropTypes.string,
  id: PropTypes.string,
  modalClass: PropTypes.string,
  dialogClass: PropTypes.string,
  contentClass: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
  onHide: PropTypes.func,
  beforeHide: PropTypes.func,
  keyboard: PropTypes.bool,
  backdrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  labelledBy: PropTypes.string,
  returnFocus: PropTypes.bool,
};

export default AppModal;
